module.exports = __webpack_public_path__ + "7310be404b3856cce27857fc31439e24.svg";